import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({
  baseURL: API,
  withCredentials: true,
});

export default client;

// Helper status mappings
export const STATUS_LABELS = {
  pending: 'Wartet auf Bestätigung',
  confirmed: 'Bestätigt',
  declined: 'Abgelehnt',
  cancelled: 'Storniert',
  arrived: 'Angekommen',
  seated: 'Sitzt',
  no_show: 'No-Show',
  completed: 'Abgeschlossen',
};

export const SOURCE_LABELS = {
  online: 'Online',
  manual: 'Manuell',
  walk_in: 'Walk-in',
};

export const SOURCE_COLOR = {
  online: '#3B82F6',
  manual: '#EAB308',
  walk_in: '#22C55E',
};

export const STATUS_COLOR = {
  pending: '#EAB308',
  confirmed: '#3B82F6',
  declined: '#9CA3AF',
  cancelled: '#9CA3AF',
  arrived: '#F97316',
  seated: '#F97316',
  no_show: '#EF4444',
  completed: '#22C55E',
};

export const WEEKDAY_LABELS = ['Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag', 'Sonntag'];
export const WEEKDAY_SHORT = ['Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa', 'So'];

export function formatDate(dateStr) {
  if (!dateStr) return '';
  const d = new Date(dateStr + 'T00:00:00');
  return d.toLocaleDateString('de-DE', { weekday: 'long', day: '2-digit', month: 'long', year: 'numeric' });
}

export function formatDateShort(dateStr) {
  if (!dateStr) return '';
  const d = new Date(dateStr + 'T00:00:00');
  return d.toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric' });
}

export function todayStr() {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

export function dateToStr(d) {
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}
